
import { createContext } from 'react';
import { LayoutContextProps } from './types';

const layoutContext = createContext<LayoutContextProps>({ getSlot: ()=>null, slotsMap: {}, registerAside: ()=>null });
export default layoutContext;
